// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center {\n  display: table;\n  margin: 0 auto;\n}", "",{"version":3,"sources":["webpack://./src/app/components/modal/modal-message/modal-message.component.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,cAAA;AAAJ","sourcesContent":["\r\n.center{\r\n    display: table;\r\n    margin: 0 auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
